var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-colour-picker"},[_c('div',{staticClass:"hue-warp"},[_c('hue-strip',{on:{"change":_vm.hueChange},model:{value:(_vm.colour),callback:function ($$v) {_vm.colour=$$v},expression:"colour"}})],1),_c('div',{staticClass:"swatches"},_vm._l((_vm.swatches),function(offset,index){return _c('div',{key:index,staticClass:"swatch",on:{"click":function($event){return _vm.selectSwatch(index, offset)}}},[_c('div',{staticClass:"swatch-picker",class:{
          'is-active': offset == _vm.activeOffset,
          'is-white': offset === '1'
        },style:({
          background: `hsl(${_vm.colour.hsl.h}, 50%, ${offset * 100}%)`
        })})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }